export default __webpack_public_path__ + "static/media/scc_titan_logoC.6fafdf41.svg";